<template>
<div>
    <pt-sub-title title="商品划分"></pt-sub-title>
    <table :class="$style['integral-goods-divide']">
     <pt-form-list-item label="经营类型：" required  @widthItem="widthItem" :widthMax="widthMax">
       <wt-radio :radios="goodsBelongLabels" v-model="goodsData.goodsBelong" @change="changeBelong" data-vv-as="经营类型"
            name="type"  v-validate="'required'"></wt-radio>
      </pt-form-list-item>
       <pt-form-list-item label="商品类型：" required>
        <wt-selector :options="goodsTypes" v-model="goodsData.type" :props="{ label: 'name', value: 'value'}" data-vv-as="商品类型"
            name="type"  v-validate="'required'" :loading="goodsTypeLoading"></wt-selector>
       </pt-form-list-item>
       <pt-form-list-item label="是否全国通用：">
         <el-switch v-model="goodsData.allAddress"></el-switch><span :class="$style['goods-form-tiptext']">打开开关后，该积分商品将作为全国通用商品</span>
       </pt-form-list-item>
       <pt-form-list-item label="地区：" required v-if="!goodsData.allAddress">
            <wt-selector :class="$style['org-select']"  data-vv-as="地区"  v-validate="'required'" :options="addressList"
            v-model="goodsData.addresses" multiple filterable allow-create default-first-option></wt-selector>
      </pt-form-list-item>
       <pt-form-list-item label="事业部归属：" required>
           <wt-selector v-model="goodsData.businessDepartmentId" :options="businessDepartments" :props="{label:'name',value:'id'}" data-vv-as="业务部"
          name="type"  v-validate="'required'"></wt-selector>
       </pt-form-list-item>
        <pt-form-list-item label="分子公司：" required>
           <wt-selector v-model="goodsData.branchesId" :options="companyList" :props="{label:'fullName',value:'id'}" filterable
            data-vv-as="分子公司" multiple name="type"  v-validate="'required'"></wt-selector>
       </pt-form-list-item>
       <pt-form-list-item label="兑换数量限制：">
         <el-switch v-model="isLimit"></el-switch><span :class="$style['goods-form-tiptext']">打开限制后，针对每个用户在一定时间内只可兑换对应数量的商品</span>
       </pt-form-list-item>
       <template v-if="isLimit">
       <pt-form-list-item required label="兑换周期：">
         <wt-radio v-model="points_goods_quota.timeDimension" :radios="exchangeTimeDimensions" data-vv-as="兑换周期"
            name="type"  v-validate="'required'"></wt-radio>
       </pt-form-list-item>
       <pt-form-list-item required label="数量限制：">
         <wt-input v-model="points_goods_quota.number" type="number" :class="$style['goods-quota-number']"></wt-input>
       </pt-form-list-item>
       </template>
       <!-- <pt-form-list-item label="是否在商城展示：">
            <div>
           <el-switch v-model="goodsData.mallVisible"></el-switch><span :class="$style['goods-form-tiptext']">开关关闭后，该商品将不在商城展示，但保持所有已设置的商品信息。</span>
           </div>
        </pt-form-list-item> -->
           <!-- <pt-form-list-item label="是否在分享中展示：">
            <div>
           <el-switch v-model="goodsData.shareVisible"></el-switch><span :class="$style['goods-form-tiptext']">开关关闭后，该商品将不在分享列表中展示，但保持所有已设置的商品信息。</span>
           </div>
        </pt-form-list-item>
         <pt-form-list-item label="是否在首页展示：">
            <div>
           <el-switch v-model="goodsOtherInfoDTO.recommend"></el-switch>
           </div>
        </pt-form-list-item> -->
        <pt-form-list-item label="可兑换等级：" required>
          <wt-input :class="$style['goods-name']"  style="display:none" v-model="canBuy" data-vv-as="至少开启一个可兑换等级" name="name"  v-validate="'required|selectArr'" ></wt-input>
          <table>
            <tr>
              <td>允许兑换</td>
              <td class="integral-goods-of-leval">等级</td>
              <td>兑换积分系数</td>
            </tr>
            <tr v-for="(item,index) in points_exchange_data" :key="index">
              <td><el-switch v-model="item.canBuy"></el-switch></td>
              <td class="integral-goods-of-leval">{{item.name}}</td>
              <td><wt-input v-model="item.magnification"></wt-input></td>
            </tr>
          </table>
        </pt-form-list-item>
    </table>
</div>
</template>
<script>
import { goodsBelongLabels } from 'json/mall-options'
import { exchangeTimeDimensions } from 'json/integral-goods-options'
import emitter from '@/mixins/emitter'
import formMixins from 'mixins/form'
export default {
  mixins: [emitter, formMixins],
  props: {
    widthMax: Number,
    goodsTypes: Array,
    goodsTypeLoading: Boolean,
    businessDepartments: Array,
    addressList: Array,
    companyList: Array,
    value: Object,
    divideData: [Object, String],
    pointsExchangeData: Array,
    pointsGoodsQuota: Object,
    isEdit: Boolean
  },
  data () {
    return {
      goodsBelongLabels: goodsBelongLabels,
      goodsData: {
      },
      points_exchange_data: this.pointsExchangeData,
      form: {},
      goodsOtherInfoDTO: {},
      integralCoefficient: [

      ],
      canBuy: null,
      isLimit: false,
      exchangeTimeDimensions: exchangeTimeDimensions,
      points_goods_quota: {
        dimensionValues: 1
      }
    }
  },
  watch: {
    pointsExchangeData (val) {
      this.points_exchange_data = this.pointsExchangeData
      this.points_exchange_data.forEach(item => {
        item.canBuy = item.canBuy || true
        item.magnification = item.magnification || 1
      })
    },
    businessDepartments: {
      handler: function (val) {
        val.forEach(item => {
          if (item.code === 'operation') {
            this.goodsData.businessDepartmentId = item.id
          }
        })
      },
      deep: true
    },
    goodsData: {
      handler: function (val) {
        this.$emit('change', JSON.stringify(val), this.points_exchange_data)
      },
      deep: true
    },
    value: {
      handler: function (val) {
        if (this.isEdit) { this.goodsData = { ...this.goodsData, ...val } }
      }
    },
    'goodsData.goodsBelong' (val) {
      this.dispatch('pt-integral-goods-form', 'getGoodsTypeList', val)
    },
    goodsOtherInfoDTO: {
      handler: function (val) {
        this.$emit('changeOtherInfo', JSON.parse(JSON.stringify(val)))
      },
      immediate: true
    },
    points_exchange_data: {
      handler: function (val) {
        this.canBuy = 0
        this.$emit('change', JSON.stringify(this.goodsData), val)
        val.forEach(item => {
          if (item.canBuy) {
            this.canBuy = this.canBuy + 1
          }
        })
      },
      deep: true
    },
    isLimit (val) {
      if (val) {

      }
    },
    points_goods_quota: {
      handler: function (val) {
        this.$emit('changeQuota', val)
      },
      deep: true
    },
    pointsGoodsQuota (val) {
      if (val) {
        this.isLimit = true
        this.points_goods_quota = val
      }
    }
  },
  methods: {
    changeBelong (val) {
      this.$delete(this.goodsData, 'type')
    },
    widthItem (val) {
      this.$emit('widthItem', val)
    }
  }
}
</script>
<style module lang="less">
@import "~less/var.less";
.integral-goods-divide{
  :global{
    .wt-selector{
      min-width: 420px;
    }
    .integral-goods-of-leval{
      padding-left: 20px;
      padding-right: 20px
    }
  }

}
.goods-quota-number{
  max-width: 200px;
}
.product-code{
  width: 350px
}
.goods-form-tiptext{
    color: @tipTextColor;
    font-size: 14px;
    line-height: 40px;
    padding-left: 15Px
}
</style>
